import React from 'react';
import './PromocodeList.less';

import {Promocode} from 'elements/promocode/Promocode';

export const PromocodeList = ({promocodes = []}) => {
	return (
		<ul className="promocode-list">
			{promocodes.map(promocode => (
				<li className="promocode-list__item" key={promocode}>
					<Promocode code={promocode}/>
				</li>
			))}
		</ul>
	);
};
